import React, {ReactNode} from "react";
import PropTypes from "prop-types";
import styles from './Button.module.scss'



export enum ButtonSize {
  Tiny = 'tiny',
  Small = 'small',
  Medium = 'normal (default)',
  Large = 'large'
}
interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    primary?: boolean,
    secondary?: boolean,
    outlined?: boolean,
    isLoading?: boolean,
    loadMessage?: string
    children: ReactNode,
    className?: string,
    color?: "success" | "error" | "warning";
    size?: "tiny" | "small" | "medium" | "large" | ButtonSize;
    variant?: "outlined" | "solid" | "link";
    startIcon?: any,
    endIcon?: any,
}


export const Button = (
  {
    primary = false,
    secondary = false,
    outlined = false,
    isLoading = false,
    loadMessage,
    size = 'medium',
    color,
    variant,
    children,

    className,
    ...props
  }: ButtonProps) => {

  const classList = [styles.btn]
  if (className){
    classList.push(className)
  }
  switch (size){
    case ButtonSize.Tiny:
      classList.push(styles.btnTiny)
      break;
    case ButtonSize.Small:
      classList.push(styles.btnSmall)
      break;
    case ButtonSize.Large:
      classList.push(styles.btnLarge)
      break;
  }

  if (primary){
    classList.push(styles.primary)
  }
  if (secondary){
    classList.push(styles.secondary)
  }

  if (outlined || variant === 'outlined'){
    classList.push(styles.outlined)
  }
  switch (color){
    case 'success': classList.push(styles.colorSuccess); break;
    case 'warning': classList.push(styles.colorWarning); break;
    case 'error': classList.push(styles.colorError); break;
  }
    return (
        <button
            type="button"
            disabled={isLoading}
            className={classList.join(' ')}
            {...props}
        ><>
          {isLoading ? <span>{loadMessage ?? 'Bezig met opslaan...'}<i className="fa-solid fa-spinner fa-spin me-3"></i></span> : children}
        </>
        </button>
    );
};



export default Button
